// Toolbox items: keep export constants declared before any addItem() uses them.
export const AGE_DATE_RANGE_TOOLBOX_NAME = "ageDateRangeCustom";
export const AGE_DATE_RANGE_TYPE = "ageDateRange";

export const AGE_RANGE_YEAR_TOOLBOX_NAME = "ageRangeYearCustom";
export const AGE_RANGE_YEAR_TYPE = "ageRangeYear";

export const ASSIGN_DRUG_KIT_TOOLBOX_NAME = "assignDrugKitCustom";
export const ASSIGN_DRUG_KIT_TYPE = "assignedDrugKit";

export const DISPENSE_DRUG_KIT_TOOLBOX_NAME = "dispenseDrugKitCustom";
export const DISPENSE_DRUG_KIT_TYPE = "dispenseDrugKit";

export const DOB_AGE_SELECTOR_TOOLBOX_NAME = "dobAgeSelectorCustom";
export const DOB_AGE_SELECTOR_TYPE = "dobAgeSelector";

export const EQ5DL_TOOLBOX_NAME = "eq5d5lCustom";
export const EQ5DL_TYPE = "eq5d5l";

export const SINGLE_CHECKBOX_TOOLBOX_NAME = "singleCheckboxCustom";
export const SINGLE_CHECKBOX_TYPE = "singleCheckbox";

export const NUMERIC_PAD_TOOLBOX_NAME = "numericPadCustom";
export const NUMERIC_PAD_TYPE = "numericPad";

export const PATIENT_VISIT_SELECTOR_TOOLBOX_NAME =
  "patientVisitDrugKitStatusCustom";
export const PATIENT_VISIT_SELECTOR_TYPE = "patientVisitDrugKitStatus";

export const SINGLE_RADIO_TOOLBOX_NAME = "singleradioCustom";
export const SINGLE_RADIO_TYPE = "singleradio";

export const GENDER_RADIO_TOOLBOX_NAME = "genderRadioGroupCustom";
export const GENDER_RADIO_TYPE = "genderRadioGroup";

export const REPLACE_DRUG_KIT_TOOLBOX_NAME = "replaceDrugKitCustom";
export const REPLACE_DRUG_KIT_TYPE = "replaceDrugKit";

export const SINGLE_SELECT_CHECKBOX_TOOLBOX_NAME = "singleSelectCheckboxCustom";
export const SINGLE_SELECT_CHECKBOX_TYPE = "singleSelectCheckbox";

export const VAS_TOOLBOX_NAME = "vasCustom";
export const VAS_TYPE = "vas";

export const VIDEO_PLAYER_TOOLBOX_NAME = "videourlCustom";
export const VIDEO_PLAYER_TYPE = "videourl";

export const VISIT_DATE_PICKER_TOOLBOX_NAME = "visitdatepickerCustom";
export const VISIT_DATE_PICKER_TYPE = "visitdatepicker";

export const HEADER_TEXT_TOOLBOX_NAME = "headertextCustom";
export const HEADER_TEXT_TYPE = "headertext";

export const PARAGRAPH_TEXT_TOOLBOX_NAME = "paragraphtextCustom";
export const PARAGRAPH_TEXT_TYPE = "paragraphtext";
